var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.6542 10.0975L12.1728 15.5788C11.9195 15.8321 11.5089 15.8322 11.2556 15.5789L8.28442 12.609L9.20156 11.6915L11.7141 14.203L16.7368 9.18018L17.6542 10.0975Z",
  fill: "#9498A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9694 5.04095C8.7899 5.04095 5.40179 8.42907 5.40179 12.6085C5.40179 16.788 8.7899 20.1761 12.9694 20.1761C17.1488 20.1761 20.5369 16.788 20.5369 12.6085C20.5369 8.42907 17.1488 5.04095 12.9694 5.04095ZM4.10449 12.6085C4.10449 7.71259 8.07343 3.74365 12.9694 3.74365C17.8653 3.74365 21.8342 7.71259 21.8342 12.6085C21.8342 17.5044 17.8653 21.4734 12.9694 21.4734C8.07343 21.4734 4.10449 17.5044 4.10449 12.6085Z",
  fill: "#9498A0"
});

function SvgCircledCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCheck);
export default __webpack_public_path__ + "static/media/circledCheck.0529ad5d.svg";
export { ForwardRef as ReactComponent };